import type { FaireProductEntity } from "../../entity_types/product";

export const p_pmetj5n23k: FaireProductEntity = {
  token: "p_pmetj5n23k",
  type: "product",
  name: "Irish Coffee Single Serve Craft Cocktail",
  brandToken: "b_kxk5df5zt5",
  brandName: "Noble Mick's - Craft Beverage Company",
  imageUrl:
    "https://cdn.faire.com/fastly/3c4d16bf827af128fba7cb600a5b9d26fefaff82e4251d81e10be197990a4642.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cf6cd99500ed039f919e5ac1a1938b6b19052f361d12ea9fc55bdc9ba99b62b4.jpeg",
    "https://cdn.faire.com/fastly/4dfe635e61b537e23cbb00c8ae26ef2569ff358c860eb6e15ab973d89b59c1a1.jpeg",
    "https://cdn.faire.com/fastly/eafb588bf053709a1eb3fc9424356082defd15eeda41eea1434d14a3304530ea.jpeg",
  ],
  priceDollars: 1.5,
  description:
    "Irish Coffee Single Serve Craft Cocktail (or Mocktail) $1.50 each- Sold In quantities of 24 (Eligible For FREE Display Box Please Order Separately). \n\nNoble Mick's single serve craft cocktails are the perfect way to enjoy a craft cocktail anywhere, anytime.  At home or on the go there is no need to have all the ingredients to make your favorite cocktail.  \n\nNoble Mick's is NOT an infusion product these cocktails are ready to go when you are. Simply add H2O and Spirit, shake or stir with ice and enjoy. Never overly sweet or artificial tasting.  Seriously...our cocktails are delicious!\n\nAt Noble Mick's we use all natural fruit and vegetable powders, natural spices and flavors and pure cane sugar.  There is a real difference!",
  tags: [],
  msrpDollars: 3,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T20:09:00.908Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
